module.exports = __webpack_public_path__ + "img/fastmind.b2810587.png";